import { Component, Input } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';

import { Tracker, Position } from '../../../entities/index';
import { TRACKER_MODES, TRACKER_SENSOR_MODES, TRACKER_TYPES } from '../../../services/constants.service';
import { TrackerService } from '../../../services/tracker.service';
import { Log } from '../../../utils/index';

@Component({
  selector: 'app-tracker-information',
  templateUrl: './tracker-information.html'
})
export class TrackerInformationComponent {
  _tracker: Tracker;
  lastPosition: Position;
  isOnline: boolean;

  modesFreq: string[] = TRACKER_MODES;
  modesSensor: string[] = TRACKER_SENSOR_MODES;
  types: string[] = TRACKER_TYPES;

  customCommand = '';

  hasModeSensor: boolean;
  hasModeFreq: boolean;
  hasCallUsage: boolean;

  constructor(protected trackerService: TrackerService, protected notificationService: NotificationsService) {
  }

  @Input()
  set tracker(tracker: Tracker) {
    this.lastPosition = (tracker && tracker.position && tracker.position.length > 0) ? tracker.position[0] : null;
    this.isOnline = this.lastPosition && this.lastPosition.is_online;
    this.enableMode(tracker);
    this.hasCallUsage = this.tracker && tracker.type == 'default' || tracker.type == 'kid' || tracker.type == 'family'
    || tracker.type == 'silver' || tracker.type == 'familykid' || tracker.type == 'familysilver';
    this._tracker = tracker;
  }

  get tracker() {
    return this._tracker;
  }

  @Log('blue')
  changeModeFreq(newMode: string) {
    this.trackerService.changeMode(this.tracker.id, newMode).subscribe(
      () => {
        this.notificationService.success('SUCCESS', `Change mode to ${newMode} command was sent successfully`);
        let freq_mode = (newMode === 'smart') ? '5M' : null;
        freq_mode = (newMode === 'live') ? '30S' : freq_mode;
        freq_mode = (newMode === 'sleep') ? '0S' : freq_mode;
        this.tracker.freq_mode = freq_mode;
      },
      result => this.notificationService.error('ERROR', 'Error while sending the change mode command')
    );
  }

  @Log('blue')
  changeModeSensor(newMode: string) {
    this.trackerService.changeMode(this.tracker.id, newMode).subscribe(
      () => {
        this.notificationService.success('SUCCESS', `Change mode to ${newMode} command was sent successfully`);
        this.tracker.sensor_mode = newMode;
      },
      result => this.notificationService.error('ERROR', 'Error while sending the change mode command')
    );
  }

  @Log('blue')
  requestVersion() {
    if (confirm('Are you sure you want to send a version command ?')) {
      this.trackerService.getVersion(this._tracker.id).subscribe(
        return_value => this.notificationService.success(
          'SUCCESS',
          'version command sent. Wait a few seconds an refresh the page'
        ),
        return_value => this.notificationService.error('ERROR', 'Error while sending the reset command')
      );
    }
  }

  @Log('blue')
  resetTimezone() {
    if (confirm('Are you sure you want to reset the timezone to UTC for this tracker ?')) {
      this.trackerService.resetTimezone(this._tracker.id).subscribe(
        return_value => this.notificationService.success('SUCCESS', 'Set UTC timezone command sent'),
        return_value => this.notificationService.error('ERROR', 'Error while sending the reset command')
      );
    }
  }

  @Log('blue')
  resetCallUsage() {
    if (confirm('Are you sure you want to reset the voice call usage for this tracker ?')) {
      this.trackerService.resetCallUsage(this._tracker.id).subscribe(
        (return_value: Tracker) => {
          this.tracker = return_value;
          this.notificationService.success('SUCCESS', 'Tracker update');
        },
        (return_value: any) => this.notificationService.error('ERROR', 'Unable to reset voice call usage')
      );
    }
  }

  @Log('blue')
  sendCustomCommand() {
    this.trackerService.customCommand(this._tracker.id, this.customCommand).subscribe(
      () => {
        this.customCommand = '';
        this.notificationService.success('SUCCESS', 'Command sent');
      },
      () => {
        this.customCommand = '';
        this.notificationService.error('ERROR', 'Unable to send the custom command')
      }
    );
  }

  enableMode(tracker: Tracker) {
    if (!tracker || !tracker.features) {
      this.hasModeFreq = false;
      this.hasModeSensor = false;
      return;
    }

    if (tracker.features.indexOf('mode_selection') !== -1) {
      this.hasModeFreq = true;
    }

    if (tracker.features.indexOf('mode_gsensor') !== -1) {
      this.hasModeSensor = true;
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/blocks/tracker-information/tracker-information.component.ts